<template>
  <div class="bg">
    <div class="button">
      <div class="search" @click="showSearch = true"></div>
      <i @click="showSearch = true" class="iconfont icon-chaxun"></i>
      <!-- <router-link :to="{ path: `/enterpriseInfo/essentialInfo/${0}` }">
        <i class="iconfont icon-add" />
      </router-link> -->
      <!-- <i class="iconfont icon-shanchu" @click="deleteSelect()" /> -->
      <van-popup
        v-model="showSearch"
        round
        position="bottom"
        :style="{ height: 'auto' }"
        closeable
      >
        <van-field
          v-model="name"
          clearable
          label="人员姓名："
          placeholder="请输入要查询的人员姓名"
        />
        <van-field
          v-model="idCardNumber"
          clearable
          label="证件号码："
          placeholder="请输入要查询的证件号码"
        />
        <div class="searchBtn">
          <el-button type="primary" size="mini" @click="itemList"> 查询记录 </el-button>
        </div>
      </van-popup>
    </div>
    <div v-show="showPagination !== 0">
      <div class="content">
        <el-card v-for="(item, index) in listInfo" :key="index">
          <el-row>
            <el-col :span="10">
              <div class="img">
                <van-image
                  height="150"
                  @click="showImage(item.attendancePhoto)"
                  :src="item.attendancePhoto"
                  fit="cover"
                />
              </div>
            </el-col>
            <el-col :span="14">
              <p>
                <span>所属项目：{{ project }}</span>
              </p>
              <p>
                <span>工人编号：{{ item.jobNo }}</span>
              </p>
              <p>
                <span>所属单位：{{ item.unitId }}</span>
              </p>
              <p>
                <span>所属班组：{{ item.teamId }}</span>
              </p>
              <p>
                <span>工人姓名：{{ item.name }}</span>
              </p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"> 证件号码：{{ item.idCardNumber }} </el-col>
            <el-col :span="24"> 进场方向：{{ item.direction }} </el-col>
            <el-col :span="24"> 考勤时间：{{ item.attendanceTime }} </el-col>
            <!-- <el-col v-if="item.temperature !== ''" :span="24">
            体温：{{ item.temperature }}
          </el-col> -->
            <el-col :span="24">体温：暂无信息 </el-col>
          </el-row>
        </el-card>
        <el-card v-show="showPagination == 0" body-style="text-align:center">
          <span>暂无数据</span>
        </el-card>
      </div>
      <el-pagination
        :current-page.sync="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :total="page.totalCount"
        layout="sizes ,pager, next "
        :on-load="itemList"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
    <el-card v-show="showPagination == 0" body-style="text-align:center">
      <span>暂无数据</span>
    </el-card>
    <div style="margin-top: 10px; text-align: right">
      <el-button v-show="showPagination == 0" size="mini" type="primary" @click="goBack">
        返回
      </el-button>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import { postListUnit } from "@/api/app/unit";
import { postTeamDetail } from "@/api/app/team";
import { postListPage } from "@/api/app/attendance";
import { postProjectId } from "@/api/app/project";
export default {
  data() {
    return {
      showSearch: false,
      listInfo: {},
      // 分页
      page: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      query: {},
      showPagination: Number,
      name: "",
      idCardNumber: "",
    };
  },
  computed: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex() {
      return this.$store.state.app.projectId;
    },
  },
  watch: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex(e) {
      if (e !== this.projectId) {
        // 获取项目信息
        this.itemList();
      }
    },
  },
  created() {
    this.itemList();
  },
  methods: {
    itemList(page, params = {}) {
      let month = "";
      if (new Date().getMonth() < 10) {
        month = "0" + (new Date().getMonth() + 1);
      }
      let date = new Date().getFullYear() + month + new Date().getDate();
      // 首页跳转携带判断今天
      if (this.$route.query.today == 1) {
        this.query.startTime =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();
        this.query.endTime =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() + 1);
      }
      if (this.name !== "") {
        this.query.name = this.name;
      }
      if (this.idCardNumber !== "") {
        this.query.idCardNumber = this.idCardNumber;
      }
      this.query.projectId = this.$store.state.app.projectId;
      postListPage(
        this.page.currentPage,
        this.page.pageSize,
        Object.assign(params, this.query)
      ).then((listPage) => {
        this.page = listPage.data;
        this.showPagination = listPage.data.result.length;
        this.showSearch = false;
        let direction = [
          {
            label: "进",
            value: 1,
          },
          {
            label: "出",
            value: 2,
          },
        ];
        // 根据vuex的寸的projectId获取所属项目名称
        postProjectId(this.$store.state.app.projectId).then((res) => {
          this.project = res.data.name;
        });
        // 所属单位
        postListUnit(this.$store.state.app.projectId).then((unit) => {
          listPage.data.result.forEach((id) => {
            unit.data.find((item) => {
              if (id.unitId == item.id) {
                id["unitId"] = item.title;
              }
              if (id.unitId !== item.id) {
                id["unitId"] = "暂无信息";
              }
            });
          });
          // 所属班组
          listPage.data.result.forEach((id) => {
            postTeamDetail(id.teamId).then((item) => {
              if (id.teamId == item.data.id) {
                id["teamId"] = item.data.name;
              }
            });
          });
          // 进场方向
          listPage.data.result.forEach((res) => {
            direction.find((item) => {
              if (res.direction == item.value) {
                res.direction = item.label;
              }
            });
          });
          this.listInfo = listPage.data.result;
        });
        // this.listInfo = res.data.result;
      });
    },
    // 返回
    goBack() {
      if (this.name !== "" || this.idCardNumber !== "") {
        location.reload();
      } else {
        this.$router.back();
      }
    },
    // 图片预览
    showImage(index) {
      ImagePreview({
        images: [index],
      });
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.itemList(this.page);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.itemList(this.page);
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  padding: 10px;
  min-height: 100vh;
  margin-bottom: 60px;
  background-color: #f0f0f0;
}
.button {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 10px;
  align-items: center;
  .search {
    width: inherit;
  }
  i {
    font-size: 24px;
    color: #606266;
  }
  .van-field:nth-child(1) {
    margin-top: 45px;
  }
  .van-popup {
    padding-bottom: 30px;
  }
  // /deep/ .el-button {
  //   margin-right: 10px;
  // }
  .searchBtn {
    margin-top: 20px;
  }
}
.content {
  font-size: 14px;
  margin-bottom: 10px;
  /deep/ .el-checkbox {
    width: 100%;
  }
  /deep/ .el-checkbox__label {
    width: 100%;
  }
  .el-card {
    margin-bottom: 10px;
  }
  .el-col {
    margin-bottom: 5px;
  }

  // 图片
  .img {
    img {
      width: 130px;
      height: 130px;
      border-radius: 4px;
    }
  }
  P {
    margin-bottom: 5px;
  }
}
// 分页
/deep/ .el-pagination {
  padding: 0;
  overflow: hidden;
}
/deep/ .el-pagination .el-select .el-input {
  margin: 0;
}
</style>
